import { useMemo } from 'react';

import { ConfluenceWorkspaceAri, IdentityUserAri } from '@atlassian/ari';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useNetworkStorageParams = (): {
	activationId: string;
	entityId: string;
	ownerAri: string;
	firstPartyApp: string;
	siteId: string;
} => {
	const { cloudId, activationId, userId } = useSessionData();

	// Memoised because this object is handed to GSN as `networkStorageParams`, which is compared by
	// reference by `React.memo(GlobalSideNavigation)` and used as the `OptionsProvider` context value.
	// A fresh object on every render defeated both, re-rendering the whole navigation tree on every
	// route-state change (COPPER-1474). All the inputs are session-stable, so this is now computed once.
	return useMemo(() => {
		const ownerAri = (userId && IdentityUserAri.create({ userId }).toString()) || '';
		const entityId = ConfluenceWorkspaceAri.create({
			siteId: cloudId,
			activationId,
		}).toString();

		return {
			activationId,
			entityId,
			ownerAri,
			firstPartyApp: 'confluence',
			siteId: cloudId,
		};
	}, [cloudId, activationId, userId]);
};
